<template>
  <v-hover>
    <v-navigation-drawer
      id="app-drawer"
      v-model="visible"
      app
      dark
      slot-scope="{ hover }"
      :mini-variant="shouldMinimizeDrawer(hover)"
      hide-overlay
      stateless
    >
      <v-img :src="image" class="navigation-scrollable">
        <v-layout class="fill-height" tag="v-list" column>
          <v-list-tile avatar>
            <v-list-tile-avatar @click="goToDashboard">
              <v-img :src="logo" height="55" contain />
            </v-list-tile-avatar>
            <v-list-tile-content class="title-text" @click="goToDashboard">
              <span class="caption mb-1">UTA User Portal</span>
              Dashboard
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon class="mr-1" @click.stop="changeDrawerMode()">
                <v-icon color="white">mdi-view-list</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider class="mb-3" />

          <v-list-tile class="mb-0" style="width: 293px;">
            <v-text-field
              class="white-input px-3 mb-2"
              label="Search..."
              v-model="search"
              color="white"
              @input="onSearchInput"
              clearable
              hide-details
            />
          </v-list-tile>

          <div v-if="search && matchedLinks.length" class="mt-2">
            <v-layout class="ma-0 pa-0" column v-for="link in matchedLinks">
              <router-link
                :to="link.to"
                class="py-2 mx-3 px-3 "
                @click="onLinkedClicked(link)"
                v-bind:class="{
                  'selected-matched-link': clickedLink == link.text,
                  'matched-link': clickedLink != link.text,
                }"
                style="white-space: pre; font-size: 14px;"
                :title="link.text"
              >
                <u>{{ truncate(link.text) }}</u>
              </router-link>
            </v-layout>
          </div>

          <div v-for="(link, index) in getFilteredLinks()">
            <v-list-tile
              v-if="!link.sublinks"
              :to="link.to"
              :active-class="color"
              @click="onLinkedClicked(link)"
              avatar
              class="v-list-item"
            >
              <v-list-tile-action
                @click="onLinkedClicked(link)"
                style="margin-right: 8px;"
              >
                <v-icon class="sublink-icon">{{ link.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content
                @click="onLinkedClicked(link)"
                class="link-text"
                v-text="link.text"
              />
              <v-list-tile-action
                v-if="link.subText"
                @click="onLinkedClicked(link)"
                class="caption mr-0"
              >
                {{ link.subText }}
              </v-list-tile-action>
            </v-list-tile>

            <v-list-group
              :value="groupExpanded(link)"
              v-if="link.sublinks"
              no-action
              style="width: 293px;"
            >
              <template v-slot:activator>
                <v-list-tile class="v-list-item drawer-group-item">
                  <v-list-tile-action>
                    <v-icon>{{ link.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content class="link-text font-weight-medium">{{
                    link.text
                  }}</v-list-tile-content>
                </v-list-tile>
              </template>
              <v-list-tile
                v-for="(child, childIndex) in link.sublinks"
                :to="child.to"
                :active-class="color"
                @click="onLinkedClicked(link)"
                avatar
                class="v-list-item"
                style="margin-left: 32px !important;"
              >
                <v-list-tile-action @click="onLinkedClicked(link)">
                  <v-icon class="sublink-icon" v-text="child.icon"></v-icon>
                </v-list-tile-action>
                <v-list-tile-content
                  @click="onLinkedClicked(link)"
                  class="link-text font-weight-light sublink-text"
                  v-text="child.text"
                ></v-list-tile-content>

                <v-list-tile-action
                  @click="onLinkedClicked(link)"
                  v-if="child.subText"
                  class="caption mr-0 font-weight-light sublink-text"
                >
                  {{ child.subText }}
                </v-list-tile-action>
              </v-list-tile>
            </v-list-group>
          </div>

          <v-layout align-end>
            <v-layout column>
              <v-divider class="mb-0" />
              <v-list-tile @click="logOut" class="v-list-item mb-2 pl-0">
                <v-list-tile-action class="mr-2">
                  <v-icon>mdi-power</v-icon>
                </v-list-tile-action>
                <v-list-tile-content class="link-text">
                  Log Out
                </v-list-tile-content>
              </v-list-tile>
            </v-layout>
          </v-layout>
        </v-layout>
      </v-img>
    </v-navigation-drawer>
  </v-hover>
</template>

<script>
// Utilities
import { mapMutations, mapState } from "vuex";
import paths from "../../router/paths";
import linkList from "./Links.js";
import * as firebase from "firebase/app";
import "firebase/database";
import { truncate } from "../../utils/helpers.js";

export default {
  data: () => ({
    logo: "https://utaw.blob.core.windows.net/images/logo+uta11.png",
    responsive: false,
    mini: false,
    userPhoneNumber: "",
    search: "",
    filteredLinks: [],
    matchedLinks: [],
    clickedLink: "",
    links: [],
    navigationSettings: [],

    // links: [
    //     {
    //         to: "/accounts",
    //         icon: "mdi-account",
    //         text: "Accounts",
    //     },
    //     {
    //         to: "/payments",
    //         id: "payments",
    //         icon: "mdi-currency-usd",
    //         text: "Payments",
    //     },
    //     {
    //         to: "/schedules",
    //         icon: "mdi-clock-outline",
    //         text: "Schedules",
    //     },
    //     {
    //         to: "/schedule-details",
    //         icon: "mdi-folder-clock-outline",
    //         text: "Schedule Details",
    //     },
    //     {
    //         to: "/payment-pickups",
    //         icon: "mdi-currency-usd",
    //         text: "Payment Pickups",
    //     },
    //     {
    //         to: "/site-visits",
    //         icon: "mdi-search-web",
    //         text: "Site Visits",
    //     },
    //     {
    //         to: "/ivr-calls",
    //         icon: "mdi-phone",
    //         text: "IVR Calls",
    //     },
    //     {
    //         to: "/documents",
    //         id: "documents",
    //         icon: "mdi-file-multiple",
    //         text: "Documents",
    //     },
    //     {
    //         to: "/publications",
    //         id: "publications",
    //         icon: "mdi-file-upload",
    //         text: "Publications",
    //     },
    //     {
    //         to: "/file-downloads",
    //         id: "file-downloads",
    //         icon: "mdi-download-multiple",
    //         text: "Downloads",
    //     },
    //     {
    //         icon: "mdi-human-child",
    //         text: "Students",
    //         sublinks: [
    //             {
    //                 to: "/students",
    //                 icon: "mdi-human-child",
    //                 text: "Students",
    //             },
    //             {
    //                 to: "/branches",
    //                 icon: "mdi-account-group",
    //                 text: "Branches",
    //             },
    //             {
    //                 to: "/classes",
    //                 icon: "mdi-chair-school",
    //                 text: "Classes",
    //             },
    //             {
    //                 to: "/student-class-info",
    //                 icon: "mdi-file-account",
    //                 text: "Students Class Info",
    //             },
    //             {
    //                 to: "/kita-alef-messages",
    //                 icon: "mdi-message-processing",
    //                 text: "Kita Alef Messages",
    //             },
    //             {
    //                 to: "/special-needs-students",
    //                 icon: "mdi-human-child",
    //                 text: "Special Needs Students",
    //             },
    //             {
    //                 to: "/student-lookup",
    //                 icon: "mdi-account-search",
    //                 text: "Students Lookup",
    //             },
    //             {
    //                 to: "/student-attendance-cards",
    //                 icon: "mdi-credit-card-multiple",
    //                 text: "Student Attendance Cards",
    //             },
    //             {
    //                 to: "/attendance-scans",
    //                 icon: "mdi-barcode-scan",
    //                 text: "Attendance Scans",
    //             },
    //         ],
    //     },
    //     {
    //         icon: "mdi-chair-school",
    //         text: "School",
    //         sublinks: [
    //             {
    //                 to: "/student-calls",
    //                 icon: "mdi-phone",
    //                 text: "Calls",
    //             },
    //             {
    //                 to: "/school-phones",
    //                 icon: "mdi-phone-classic",
    //                 text: "Phones",
    //             },
    //             {
    //                 to: "/teacher-settings",
    //                 icon: "mdi-settings",
    //                 text: "Teacher Settings",
    //             },
    //             {
    //                 to: "/tips",
    //                 icon: "mdi-currency-usd",
    //                 text: "Tips",
    //             },
    //             {
    //                 to: "/tip-payments",
    //                 icon: "mdi-currency-usd",
    //                 text: "Tip Payments",
    //             },
    //             {
    //                 to: "/tip-transactions",
    //                 icon: "mdi-currency-usd",
    //                 text: "Tip Transactions",
    //             },
    //             {
    //                 to: "/teacher-relations",
    //                 icon: "mdi-all-inclusive",
    //                 //arrow-expand-horizontal infinity
    //                 text: "Teacher Relations",
    //             },
    //             {
    //                 to: "/appointments",
    //                 icon: "mdi-calendar-clock",
    //                 text: "Appointments",
    //             },
    //             {
    //                 to: "/not-assined-students",
    //                 icon: "mdi-human-child",
    //                 text: "Not Assined Students",
    //             },
    //             {
    //                 to: "/school/menahal-broadcasts",
    //                 icon: "mdi-access-point",
    //                 text: "Menahal Broadcast",
    //             },
    //         ],
    //     },
    //     {
    //         icon: "mdi-account-edit",
    //         text: "Registration",
    //         sublinks: [
    //             {
    //                 to: "/kollel-applications",
    //                 icon: "mdi-file-document",
    //                 text: "Kollel Applications",
    //             },
    //             {
    //                 to: "/kollel-application-logs",
    //                 icon: "mdi-folder-search",
    //                 text: "Kollel Application Logs",
    //             },
    //             {
    //                 to: "/vm-forms",
    //                 icon: "mdi-file-document",
    //                 text: "VM Forms",
    //             },
    //             {
    //                 to: "/vm-form-logs",
    //                 icon: "mdi-folder-search",
    //                 text: "VM Form Logs",
    //             },
    //             {
    //                 to: "/vm-account-status",
    //                 icon: "mdi-account-supervisor-circle",
    //                 text: "VM Account Status",
    //             },
    //             {
    //                 to: "/new-family-applications",
    //                 icon: "mdi-account-box-multiple",
    //                 text: "New Family Applications",
    //             },
    //             {
    //                 to: "/hs-new-students",
    //                 icon: "mdi-human-child",
    //                 text: "HS New Students",
    //             },
    //             {
    //                 to: "/hs-students-import",
    //                 icon: "mdi-account-multiple",
    //                 text: "HS Imported Students",
    //             },
    //             {
    //                 to: "/hs-matched-students",
    //                 icon: "mdi-account-check",
    //                 text: "HS Matched Students",
    //             },
    //             {
    //                 to: "/hs-students-view",
    //                 icon: "mdi-account-box-multiple",
    //                 text: "HS Students View",
    //             },
    //         ],
    //     },
    //     {
    //         icon: "mdi-account-switch",
    //         text: "Communications",
    //         sublinks: [
    //             {
    //                 to: "/communications/sms-pending-messages",
    //                 icon: "mdi-message-processing",
    //                 text: "Pending Messages",
    //             },
    //             {
    //                 to: "/communications/account-messages",
    //                 icon: "mdi-message-processing",
    //                 text: "All Messages",
    //             },
    //             {
    //                 to: "/communications/pending-callback-requests",
    //                 icon: "mdi-phone-return",
    //                 text: "Pending Callback Requests",
    //                 subText: "0",
    //             },
    //             {
    //                 to: "/communications/callback-requests",
    //                 icon: "mdi-phone-return",
    //                 text: "All Callback Requests",
    //             },
    //             {
    //                 to: "/contactUs",
    //                 id: "contactUs",
    //                 icon: "mdi-email",
    //                 text: "Contact Us",
    //             },
    //             {
    //                 to: "/communications/emails",
    //                 icon: "mdi-email",
    //                 text: "Emails",
    //             },
    //             {
    //                 to: "/communications/calls",
    //                 icon: "mdi-phone",
    //                 text: "Calls",
    //             },
    //             {
    //                 to: "/communications/callback-summary",
    //                 icon: "mdi-table",
    //                 text: "Callback Summary",
    //             },
    //             {
    //                 to: "/communications/queue-report",
    //                 icon: "mdi-account-multiple",
    //                 text: "Queue Report",
    //             },
    //             {
    //                 to: "/communications/feedback",
    //                 icon: "mdi-message-alert",
    //                 text: "הקול ",
    //             },
    //         ],
    //     },
    //     {
    //         icon: "mdi-food",
    //         text: "Food Distribution",
    //         sublinks: [
    //             {
    //                 to: "/food-distribution/families",
    //                 icon: "mdi-account-group",
    //                 text: "Families",
    //             },
    //             {
    //                 to: "/food-distribution/siblings",
    //                 icon: "mdi-human-male-boy",
    //                 text: "Siblings",
    //             },
    //             {
    //                 to: "/food-distribution/distributions",
    //                 icon: "mdi-truck-delivery",
    //                 text: "Distributions",
    //             },
    //             {
    //                 to: "/food-distribution/routes",
    //                 icon: "mdi-routes",
    //                 text: "Routes",
    //             },
    //             {
    //                 to: "/food-distribution/scans",
    //                 icon: "mdi-barcode-scan",
    //                 text: "Scans",
    //             },
    //             {
    //                 to: "/food-distribution/feedback",
    //                 icon: "mdi-message-alert",
    //                 text: "Feedback",
    //             },
    //             {
    //                 to: "/food-distribution/changes",
    //                 icon: "mdi-account-edit",
    //                 text: "Enrollment Changes",
    //             },
    //             {
    //                 to: "/food-distribution/logs",
    //                 icon: "mdi-file-document",
    //                 text: "Logs",
    //             },
    //         ],
    //     },
    //     {
    //         icon: "mdi-vote",
    //         text: "Votes",
    //         sublinks: [
    //             {
    //                 to: "/voting-master-list",
    //                 icon: "mdi-account",
    //                 text: "Master List",
    //             },
    //             {
    //                 to: "/doe",
    //                 icon: "mdi-account-multiple",
    //                 text: "DOE",
    //             },
    //             {
    //                 to: "/yg-students",
    //                 icon: "mdi-human-child",
    //                 text: "Students",
    //             },
    //             {
    //                 to: "/voting-reg-notes",
    //                 icon: "mdi-note-multiple",
    //                 text: "Notes",
    //             },
    //             {
    //                 to: "/voting-reg-auto-match",
    //                 icon: "mdi-account-switch",
    //                 text: "Auto Match",
    //             },
    //         ],
    //     },
    //     {
    //         icon: "mdi-bullhorn-outline",
    //         text: "Broadcast",
    //         sublinks: [
    //             {
    //                 to: "/phone",
    //                 icon: "mdi-phone",
    //                 text: "Phone Numbers",
    //             },
    //             {
    //                 to: "/sms",
    //                 icon: "mdi-message-processing",
    //                 text: "SMS",
    //             },
    //             {
    //                 to: "/calls",
    //                 icon: "mdi-phone-log",
    //                 text: "Calls",
    //             },
    //             {
    //                 to: "/broadcasts",
    //                 icon: "mdi-access-point",
    //                 text: "Broadcast List",
    //             },
    //             {
    //                 to: "/audio-library",
    //                 icon: "mdi-animation-play",
    //                 text: "Audio Library",
    //             },
    //             {
    //                 to: "/surveys",
    //                 icon: "mdi-comment-question",
    //                 text: "Survey",
    //             },
    //             {
    //                 to: "/immunization-broadcasts",
    //                 icon: "mdi-calendar-clock",
    //                 text: "Immunization Broadcasts",
    //             },
    //         ],
    //     },
    //     {
    //         icon: "mdi-phone-in-talk",
    //         text: "Camp Calling Card",
    //         sublinks: [
    //             {
    //                 to: "/camp-calling-card/students",
    //                 icon: "mdi-human-child",
    //                 text: "Students",
    //             },
    //             {
    //                 to: "/camp-calling-card/calls",
    //                 icon: "mdi-phone",
    //                 text: "Calls",
    //             },
    //             {
    //                 to: "/camp-calling-card/camp-settings",
    //                 icon: "mdi-settings",
    //                 text: "Settings",
    //             },
    //             {
    //                 to: "/camp-calling-card/signalwire-calls",
    //                 icon: "mdi-file-document",
    //                 text: "Call Logs",
    //             },
    //             {
    //                 to: "/camp-calling-card/call-stats",
    //                 icon: "mdi-chart-bar",
    //                 text: "Call Stats",
    //             },
    //         ],
    //     },
    //     {
    //         icon: "mdi-home",
    //         text: "Lapidus Day Camp",
    //         sublinks: [
    //             {
    //                 to: "/lapidus/billing",
    //                 icon: "mdi-account",
    //                 text: "Billing",
    //             },
    //             {
    //                 to: "/lapidus/accounts",
    //                 icon: "mdi-account",
    //                 text: "Accounts",
    //             },
    //             {
    //                 to: "/lapidus/daycamp-accounts",
    //                 icon: "mdi-account",
    //                 text: "Day Camp Accounts",
    //             },
    //             {
    //                 to: "/lapidus/payments",
    //                 icon: "mdi-currency-usd",
    //                 text: "Payments",
    //             },
    //             {
    //                 to: "/lapidus/unprocessed-payments",
    //                 icon: "mdi-clock-outline",
    //                 text: "Unprocessed Payments",
    //             },
    //             {
    //                 to: "/lapidus/students",
    //                 icon: "mdi-human-child",
    //                 text: "Students",
    //             },
    //             {
    //                 to: "/lapidus/documents",
    //                 icon: "mdi-file-multiple",
    //                 text: "Documents",
    //             },
    //             {
    //                 to: "/lapidus/classes",
    //                 icon: "mdi-chair-school",
    //                 text: "Classes",
    //             },
    //             {
    //                 to: "/lapidus/class-summary",
    //                 icon: "mdi-chair-school",
    //                 text: "Class Summary",
    //             },
    //             {
    //                 to: "/lapidus/residents",
    //                 icon: "mdi-home-variant",
    //                 text: "Lapidus Residents",
    //             },
    //         ],
    //     },
    //     {
    //         icon: "mdi-home",
    //         text: "YK Camp",
    //         sublinks: [
    //             {
    //                 to: "/ykc/accounts",
    //                 icon: "mdi-account",
    //                 text: "Accounts",
    //             },
    //             {
    //                 to: "/ykc/accounts-extended",
    //                 icon: "mdi-account",
    //                 text: "Accounts Extended",
    //             },
    //             {
    //                 to: "/ykc/payments",
    //                 icon: "mdi-currency-usd",
    //                 text: "Payments",
    //             },
    //             {
    //                 to: "/ykc/payment-details",
    //                 icon: "mdi-currency-usd",
    //                 text: "Payment Receipts",
    //             },
    //             {
    //                 to: "/ykc/unprocessed-payments",
    //                 icon: "mdi-clock-outline",
    //                 text: "Unprocessed Payments",
    //             },
    //             {
    //                 to: "/ykc/students",
    //                 icon: "mdi-human-child",
    //                 text: "Students",
    //             },
    //             {
    //                 to: "/ykc/documents",
    //                 icon: "mdi-file-multiple",
    //                 text: "Documents",
    //             },
    //             {
    //                 to: "/ykc/recent-pages",
    //                 icon: "mdi-account-multiple",
    //                 text: "Recent Accounts",
    //             },
    //             {
    //                 to: "/ykc/notes",
    //                 icon: "mdi-note-multiple",
    //                 text: "Notes",
    //             },
    //             {
    //                 to: "/ykc/billing-report",
    //                 icon: "mdi-chart-bar",
    //                 text: "Billing Report",
    //             },
    //             {
    //                 to: "/ykc/billing-summary",
    //                 icon: "mdi-chart-bar",
    //                 text: "Billing Summary",
    //             },
    //             {
    //                 to: "/ykc/camp-families",
    //                 icon: "mdi-account-group",
    //                 text: "Camp Families",
    //             },
    //             {
    //                 to: "/ykc/camp-distribution-requests",
    //                 icon: "mdi-message-alert",
    //                 text: "Camp Distribution Requests",
    //             },
    //             {
    //                 to: "/ykc/camp-menu-summary",
    //                 icon: "mdi-chart-bar",
    //                 text: "Camp Menu Summary",
    //             },
    //             {
    //                 to: "/ykc/camp-distribution-logs",
    //                 icon: "mdi-folder-search",
    //                 text: "Camp Distribution Logs",
    //             },
    //             {
    //                 to: "/ykc/camp-distribution-ivr-calls",
    //                 icon: "mdi-phone",
    //                 text: "Camp Distribution IVR Calls",
    //             },
    //             {
    //                 to: "/ykc/camp-distributions",
    //                 icon: "mdi-package-variant",
    //                 text: "Camp Distributions",
    //             },
    //             {
    //                 to: "/ykc/camp-menu-items",
    //                 icon: "mdi-food",
    //                 text: "Camp Menu Items",
    //             },
    //             {
    //                 to: "/ykc/camp-distribution-default-totals",
    //                 icon: "mdi-poll",
    //                 text: "Camp Distribution Default Totals",
    //             },
    //         ],
    //     },
    //     {
    //         icon: "mdi-currency-usd",
    //         text: "Dinner",
    //         sublinks: [
    //             {
    //                 to: "/dinner/donors",
    //                 icon: "mdi-account",
    //                 text: "Donors",
    //             },
    //             {
    //                 to: "/dinner/ivr-calls",
    //                 icon: "mdi-phone",
    //                 text: "IVR Calls",
    //             },
    //             {
    //                 to: "/dinner/site-visits",
    //                 icon: "mdi-search-web",
    //                 text: "Site Visits",
    //             },
    //             {
    //                 to: "/dinner/payments",
    //                 id: "payments",
    //                 icon: "mdi-currency-usd",
    //                 text: "Payments",
    //             },
    //             {
    //                 to: "/dinner/news",
    //                 id: "payments",
    //                 icon: "mdi-newspaper",
    //                 text: "Dinner News",
    //             },
    //             {
    //                 to: "/dinner/kapures",
    //                 icon: "fa-kiwi-bird",
    //                 text: "Kapures",
    //             },
    //             {
    //                 to: "/dinner/kapures-totals",
    //                 icon: "mdi-chart-bar",
    //                 text: "Kapures Total",
    //             },
    //         ],
    //     },
    //     {
    //         icon: "mdi-cash-multiple",
    //         text: "Purim",
    //         sublinks: [
    //             {
    //                 to: "/purim/students",
    //                 icon: "mdi-human-child",
    //                 text: "Students",
    //             },
    //             {
    //                 to: "/purim/transactions",
    //                 icon: "mdi-currency-usd",
    //                 text: "Transactions",
    //             },
    //             {
    //                 to: "/purim/tracking-details",
    //                 icon: "mdi-account-details",
    //                 text: "Tracking Details",
    //             },
    //             {
    //                 to: "/purim/gifts",
    //                 icon: "mdi-gift",
    //                 text: "Gifts",
    //             },
    //             {
    //                 to: "/purim/totals",
    //                 icon: "mdi-chart-bar",
    //                 text: "Totals",
    //             },
    //             {
    //                 to: "/purim/settings",
    //                 icon: "mdi-settings",
    //                 text: "Settings",
    //             },
    //         ],
    //     },
    //     // {
    //     //     icon: "mdi-eyedropper",
    //     //     text: "Covid 19 Test",
    //     //     sublinks: [
    //     //         {
    //     //             to: "/covid-test/test-entry",
    //     //             icon: "mdi-account",
    //     //             text: "Student Entry",
    //     //         },
    //     //     ],
    //     // },
    //     // {
    //     //     icon: "mdi-account-search",
    //     //     text: "Covid 19 Screening",
    //     //     sublinks: [
    //     //         {
    //     //             to: "/covid-screening/covid-screening-students",
    //     //             icon: "mdi-account-search",
    //     //             text: "Student Status",
    //     //         },
    //     //         {
    //     //             to: "/covid-screening/covid-screening-logs",
    //     //             icon: "mdi-file-document",
    //     //             text: "Logs",
    //     //         },
    //     //         {
    //     //             to: "/covid-screening/covid-screening-sms-sessions",
    //     //             icon: "mdi-message-processing",
    //     //             text: "Sms Sessions",
    //     //         },
    //     //         // {
    //     //         //     to: "/covid-screening/covid-screening-status",
    //     //         //     icon: "mdi-account-search",
    //     //         //     text: "Account Status",
    //     //         // },
    //     //     ],
    //     // },
    //     {
    //         icon: "mdi-chair-school",
    //         text: "Day Camp",
    //         sublinks: [
    //             {
    //                 to: "/day-camp/status-lookup",
    //                 icon: "mdi-human-child",
    //                 text: "Students Status",
    //             },
    //         ],
    //     },
    //     {
    //         icon: "mdi-home-map-marker",
    //         text: "Girls Camp",
    //         sublinks: [
    //             {
    //                 to: "/girls-camp/accounts",
    //                 icon: "mdi-account",
    //                 text: "Accounts",
    //             },
    //             {
    //                 to: "/girls-camp/payments",
    //                 icon: "mdi-currency-usd",
    //                 text: "Payments",
    //             },
    //             {
    //                 to: "/girls-camp/students",
    //                 icon: "mdi-human-child",
    //                 text: "Students",
    //             },
    //             {
    //                 to: "/girls-camp/covid-labels",
    //                 icon: "mdi-label",
    //                 text: "Covid-19 Labels",
    //             },
    //             {
    //                 to: "/girls-camp/classes",
    //                 icon: "mdi-chair-school",
    //                 text: "Classes & Bunks",
    //             },
    //             {
    //                 to: "/girls-camp/class-summary",
    //                 icon: "mdi-chair-school",
    //                 text: "Class Summary",
    //             },
    //         ],
    //     },
    //     // {
    //     //     icon: "mdi-content-copy",
    //     //     text: "Camp Petitions",
    //     //     sublinks: [
    //     //         {
    //     //             to: "/camp-petition/submissions",
    //     //             icon: "mdi-content-copy",
    //     //             text: "Submissions",
    //     //         },
    //     //         {
    //     //             to: "/camp-petition/sms",
    //     //             icon: "mdi-comment-text",
    //     //             text: "SMS Sessions",
    //     //         },
    //     //     ],
    //     // },
    //     {
    //         icon: "mdi-settings",
    //         text: "Settings",
    //         sublinks: [
    //             {
    //                 to: "/settings/users",
    //                 icon: "mdi-account-outline",
    //                 text: "Users",
    //             },
    //             {
    //                 to: "/settings/roles",
    //                 icon: "mdi-key",
    //                 text: "Roles",
    //             },
    //             {
    //                 to: "/settings/settings",
    //                 icon: "mdi-settings",
    //                 text: "Settings",
    //             },
    //         ],
    //     },
    // ],
  }),
  watch: {
    responsive(newValue, oldValue) {
      this.mini = newValue;
    },
    $route(to, from) {
      this.filteredLinks = this.getLinks();
    },
  },
  computed: {
    ...mapState("app", ["image", "color"]),
    visible: {
      get() {
        return this.showDrawer();
      },
      set(val) {
        this.setDrawer(val);
      },
    },
    items() {
      return this.$t("Layout.View.items");
    },
  },
  async created() {
    this.links = JSON.parse(JSON.stringify(linkList));

    await this.loadNavigationSettings();

    this.filteredLinks = this.getLinks();

    await this.loadNavigationCounts();

    this.firebaseSetup();
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    this.filteredLinks = this.getLinks();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    async loadNavigationSettings() {
      const response = await this.$http.get(
        "api/adminPortal/getNavigationSettings?userName=" +
          this.$store.state.authentication.user
      );

      this.navigationSettings = response;
    },
    getSubtext(link) {
      return link.subText;
    },
    firebaseSetup() {
      const firebaseConfig = {
        apiKey: "AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE",
        authDomain: "utaw.firebaseapp.com",
        databaseURL: "https://utaw.firebaseio.com",
        projectId: "project-683582246459980907",
        storageBucket: "project-683582246459980907.appspot.com",
        messagingSenderId: "193425158146",
        appId: "1:193425158146:web:f1ae134a803fb75832371b",
      };

      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }

      var database = firebase.database();
      var ref = firebase.database().ref("navigation");

      // const query = ref
      //     .orderByChild("Name")
      //     .equalTo("CallbackRequest")
      //     .limitToLast(1);

      ref.on(
        "value",
        (snapshot) => {
          Object.values(snapshot.val()).map((navigation) => {
            const link = this.links.find((l) => l.text == "Communications");

            switch (navigation.Name) {
              case "CallbackRequest":
                const callbackLink = link.sublinks.find(
                  (l) => l.text == "Pending Callback Requests"
                );

                callbackLink.subText = navigation.Count;

                break;
              case "Messages":
                const messagesSublink = link.sublinks.find(
                  (l) => l.text == "Pending Messages"
                );

                messagesSublink.subText = navigation.Count;

                break;
              default:
                break;
            }
          });
        },
        function(error) {
          console.log("Error: " + error.code);
        }
      );
    },
    showDrawer() {
      if ([null, "Login"].includes(this.$route.name)) return false;
      if (this.$route.name === "RedeemCoupon") {
        return this.$store.state.app.drawer === true;
      }
      return true;
    },
    getIsAdmin(isAdmin) {
      if (!isAdmin || isAdmin == "false") return false;

      return true;
    },
    getClaims(claims) {
      if (Array.isArray(claims)) return claims;

      return claims.split(",");
    },
    truncate(text) {
      return truncate(text, 35);
    },
    onLinkedClicked(link) {
      if (this.clickedLink == link.text) return;

      this.clickedLink = link.text;
    },
    groupExpanded(link) {
      return link.sublinks.some((sl) => {
        const parent = this.clickedLink.split("/")[0];
        const child = this.clickedLink.split("/")[1];

        return link.text == parent && sl.text == child;
      });
    },
    onSearchInput(value) {
      this.filteredLinks = this.getLinks();
      this.matchedLinks = this.getMatchedLinks();
    },
    getFilteredLinks() {
      return this.filteredLinks;
    },
    getMatchedLinks() {
      const links = this.getLinks();

      const linksWithSublinks = JSON.parse(
        JSON.stringify(
          links.filter((link) => link.sublinks && link.sublinks.length)
        )
      );
      const linksWithoutSublinks = links.filter(
        (link) => !link.sublinks || !link.sublinks.length
      );

      let matchedSublinks = linksWithSublinks
        .map((link) => {
          const sublinks = link.sublinks.filter(
            (sl) =>
              sl.text &&
              sl.text.toLowerCase().includes(this.search.toLowerCase())
          );

          return sublinks.map((sl) => {
            sl.text = link.text + "/" + sl.text;

            return sl;
          });
        })
        .flat();

      return linksWithoutSublinks.concat(matchedSublinks);
    },
    getLinks() {
      let links = this.links;

      if (
        this.$store.state.authentication.plivoPhone &&
        !links.find((l) => l.text == "Phone Settings")
      ) {
        links.push({
          to: "/phone-detail/" + this.$store.state.authentication.plivoPhone,
          icon: "mdi-phone",
          text: "Phone Settings",
        });
      }

      //Check Navigation Settings
      links = links
        .map((link) => {
          if (link.sublinks) {
            link.sublinks = link.sublinks.filter(
              (l) => !this.isHidden(l, link)
            );
          }

          return link;
        })
        .filter((l) => {
          if (this.isHidden(l)) return;

          return !l.sublinks || l.sublinks.length;
        });

      this.setupFavorites(links);

      if (this.getIsAdmin(this.$store.getters["authentication/isAdmin"]))
        return links.filter(this.filterLink);

      const claims = this.getClaims(
        this.$store.getters["authentication/getClaims"]
      );

      const pagesAllowed = paths.filter(
        (p) => p.name && claims.includes(p.name)
      );

      links = links.filter((link) => {
        if (!link.sublinks) {
          const to = link.to.split("/")[1] ? link.to.split("/")[1] : link.to;

          return pagesAllowed
            .map((p) => {
              const path = p.path.split("/")[1] ? p.path.split("/")[1] : p.path;

              return "/" + path;
            })
            .includes("/" + to);
        }

        return link.sublinks.some((sl) => {
          const paths = pagesAllowed.map((p) =>
            p.path.replace(/\/:[^/]+/g, "")
          );

          return paths.includes(sl.to) || paths.includes(sl.basePath);
        });
      });

      if (links.length == 1 && links[0].sublinks && links[0].sublinks.length) {
        links = links[0].sublinks.filter((l) => {
          const paths = pagesAllowed.map((p) =>
            p.path.replace(/\/:[^/]+/g, "")
          );

          return paths.includes(l.to) || paths.includes(l.basePath);
        });
      }

      return links
        .map((link) => {
          const mappedLink = {
            icon: link.icon,
            to: link.to,
            text: link.text,
            subText: link.subText,
          };

          if (link.sublinks) {
            mappedLink.sublinks = link.sublinks.filter((l) => {
              const paths = pagesAllowed.map((p) =>
                p.path.replace(/\/:[^/]+/g, "")
              );

              return paths.includes(l.to) || paths.includes(l.basePath);
            });
          }

          return mappedLink;
        })
        .filter(this.filterLink);
    },
    isHidden(link, parentLink = null) {
      return this.navigationSettings.some(
        (n) =>
          n.navigationItem == link.text &&
          n.navigationGroup == (parentLink ? parentLink.text : "main") &&
          n.hidden
      );
    },
    filterLink(link) {
      //if (this.isHidden(link)) return;

      return (
        !this.search ||
        link.text.toLowerCase().includes(this.search) ||
        (link.sublinks &&
          link.sublinks.some(
            (sl) =>
              sl.text &&
              sl.text.toLowerCase().includes(this.search.toLowerCase())
          ))
      );
    },
    setupFavorites(links) {
      let favoritesItems = [];
      const sublinks = links
        .filter((l) => l.sublinks)
        .map((item) => {
          return item.sublinks.map((sublink) => {
            sublink.parent = item.text;

            return sublink;
          });
        })
        .flat();

      this.navigationSettings
        .filter((n) => n.isFavorite)
        .forEach((ns) => {
          const item = sublinks.find(
            (i) => i.parent == ns.navigationGroup && i.text == ns.navigationItem
          );

          if (!item) return;

          favoritesItems.push({
            text: item.text,
            icon: item.icon,
            subText: item.subText,
            to: item.to,
          });
        });

      favoritesItems = favoritesItems.sort((a, b) => {
        if (a.sortOrder < b.sortOrder) {
          return -1;
        }
        if (a.sortOrder > b.sortOrder) {
          return 1;
        }
        return 0;
      });

      if (favoritesItems.length) {
        links.unshift({
          text: "Favorites",
          icon: "mdi-star-box",
          sublinks: favoritesItems,
        });
      }
    },
    shouldMinimizeDrawer(hover) {
      if (this.$route.name == "NotAssinedStudents") return true;

      if (!this.mini) return false;

      return !hover;
    },
    changeDrawerMode(hover) {
      this.mini = !this.mini;
    },
    logOut() {
      this.$router.push({
        name: "Login",
        query: { redirect: this.$route.fullPath },
      });
    },
    goToDashboard() {
      this.$router.push({
        name: "UtaDashboard",
      });
    },
    async loadUserPhone() {
      const userPhone = await this.$http.get(
        "api/broadcast/getUserPhoneNumber?user=" +
          this.$store.state.authentication.user
      );

      if (userPhone.number) {
        this.links.push({
          to: "/phone-detail/" + userPhone.number,
          icon: "mdi-phone",
          text: "Phone Settings",
        });

        const claims = this.getClaims(
          this.$store.getters["authentication/getClaims"]
        );

        claims.push("Phone Detail");

        //commit("CLAIMS", claims);
        this.$store.dispatch("authentication/CLAIMS", claims);

        // this.links.splice(index, 0, {
        //     to: "/phone-detail/" + userPhone.number,
        //     icon: "mdi-phone",
        //     text: "Phone Number",
        // });
      }
    },
    async loadNavigationCounts() {
      const counts = await this.$http.get(
        "api/adminPortal/getNavigationCounts"
      );

      counts.forEach((count) => {
        let link = this.links.find((l) => l.id == count.id);

        if (!link) {
          link = this.links.find((l) =>
            l.sublinks.some((s) => s.id == count.id)
          );

          if (!link) return;

          link = link.sublinks.find((sl) => sl.id == count.id);
        }

        link.subText = count.text;
      });
    },
  },
};
</script>

<style lang="scss">
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }

  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }

  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }
}

.link-text {
  font-weight: 300;
  font-size: 14px !important;
  margin-bottom: 5px;
  margin-top: 5px;
}

.sublink-text {
  font-size: 13px !important;
}
.sublink-icon {
  font-size: 20px !important;
}

.title-text {
  font-weight: 400;
  font-size: 18px !important;
  margin-bottom: 5px;
  margin-top: 5px;
  font-family: Roboto, sans-serif !important;
  line-height: 1 !important;
}

.navigation-scrollable {
  background: rgb(238, 174, 202);
  background: radial-gradient(circle, #f0f0f0 0%, #fff 100%);
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.drawer-group-item:hover {
  background-color: #424242 !important;
  box-shadow: none !important;
}
.drawer-group-item {
  margin-left: 8px !important;
  margin-top: 8px !important;
}

.selected-matched-link {
  color: #43a047;
}
.matched-link {
  color: #fff;
}
</style>
